(function () {
	const NEWSLETTER_HEADING_SELECTOR = '[data-footer-newsletter-heading]';
	const HIGHLIGHT_CLASS = 'footer-newsletter__highlight';
	const PILL_FORM_SELECTOR = '.newsletter-form--pill .pill-field__input';
	const CONTACT_FIELD_SELECTOR = '.contact-card__fields .field input, .contact-card__fields .field textarea';
	const GLOBAL_FIELD_SELECTOR = ".field input:not([type='checkbox']):not([type='radio']), .field textarea, .field .field__input, .field select";

	const parseHighlightWords = (value = '') =>
		value
			.split(',')
			.map((entry) => entry.trim())
			.filter((entry) => entry.length > 0);

	const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

	const highlightTokens = (headingEl, words) => {
		if (!headingEl || !words.length || typeof NodeFilter === 'undefined') {
			return;
		}

		const doc = headingEl.ownerDocument;

		words.forEach((token) => {
			const isPhrase = /\s/.test(token);
			const pattern = isPhrase ? `(${escapeRegExp(token)})` : `\\b(${escapeRegExp(token)})\\b`;
			const walker = doc.createTreeWalker(headingEl, NodeFilter.SHOW_TEXT);
			const textNodes = [];

			while (walker.nextNode()) {
				const node = walker.currentNode;
				const parent = node.parentNode;
				if (parent && parent.classList && parent.classList.contains(HIGHLIGHT_CLASS)) {
					continue;
				}
				textNodes.push(node);
			}

			textNodes.forEach((node) => {
				const text = node.textContent;
				const regex = new RegExp(pattern, 'gi');
				if (!regex.test(text)) {
					return;
				}
				regex.lastIndex = 0;

				const fragment = doc.createDocumentFragment();
				let lastIndex = 0;
				let match;

				while ((match = regex.exec(text)) !== null) {
					const start = match.index;
					const matchText = match[0];
					if (start > lastIndex) {
						fragment.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
					}
					const span = doc.createElement('span');
					span.className = HIGHLIGHT_CLASS;
					span.textContent = matchText;
					fragment.appendChild(span);
					lastIndex = start + matchText.length;
				}

				if (lastIndex < text.length) {
					fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));
				}

				node.replaceWith(fragment);
			});
		});
	};

	const applyNewsletterHighlight = () => {
		document.querySelectorAll(NEWSLETTER_HEADING_SELECTOR).forEach((heading) => {
			const raw = heading.getAttribute('data-highlight-words') || '';
			const words = parseHighlightWords(raw);
			if (!words.length) {
				return;
			}

			if (heading.classList.contains('animated-text')) {
				heading.classList.remove('animated-text');
			}

			if (!heading.dataset.footerHighlightOriginal) {
				const original = heading.dataset.text || heading.textContent || '';
				heading.dataset.footerHighlightOriginal = original;
			}

			const original = heading.dataset.footerHighlightOriginal;
			heading.textContent = original;
			highlightTokens(heading, words);
		});
	};

	const enhancePillForms = () => {
		document.querySelectorAll(`${GLOBAL_FIELD_SELECTOR}, ${PILL_FORM_SELECTOR}, ${CONTACT_FIELD_SELECTOR}`).forEach((input) => {
			if (input.dataset.pillEnhanced === 'true') {
				return;
			}

			const toggle = () => {
				const hasValue = !!input.value;
				input.classList.toggle('has-value', hasValue);
				const parentField = input.closest('.field');
				if (parentField) {
					parentField.classList.toggle('field--has-value', hasValue);
				}
			};

			input.addEventListener('input', toggle);
			input.addEventListener('blur', toggle);
			toggle();

			input.dataset.pillEnhanced = 'true';
		});
	};

	const footer = () => {
		const footerDetails = document.querySelectorAll('.footer .accordion details');
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

		applyNewsletterHighlight();
		enhancePillForms();
	};

	document.addEventListener('shopify:section:load', footer);
	footer();
})();
